import { useRef } from 'react';
import { breakpoints } from '@ui/css';
import { HideFor, ShowFor } from '@utils/react';
import { TaskContainerContext } from '../components/organism.task/hook.task-breakpoints.js';
import { TaskHeader } from '../components/organism.task/molecule.task-header/_task-header.js';
import { PageContext } from '../context.js';
import { useOpgavekompleksetComponent } from '../state/context.data.js';
import { useOpgavekompleksetEntry } from '../state/hook.entry.js';
import { shouldShowReport } from '../state/util.should-show-report.js';
import { container, content, headerAndPie, pieChart, tasksWrapper, tasksContainer, taskAccordionsHeader, taskAccordions } from './_page.results.style.js';
import { ResultsPieChart } from './atom.pie-chart/_pie-chart.js';
import { ResultsFooter } from './molecule.footer.js';
import { ResultsHeader } from './molecule.header.js';
import { TaskAccordion } from './molecule.task-accordion/_task-accordion.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function ResultsPage(props) {
  const ref = useRef(null);
  const tasksRef = useRef(null);
  const component = useOpgavekompleksetComponent();
  const tasksWithEntries = useOpgavekompleksetEntry({
    select: entry => component.data.tasks.filter(task =>
    // We omit infopages from the results, See ADO #114226
    (task.type !== "task" || task.taskType !== "InfoPage") && !!entry?.data.tasks[task.id])
  });
  return /*#__PURE__*/jsx(TaskContainerContext.Provider, {
    value: tasksRef,
    children: /*#__PURE__*/jsx(PageContext.Provider, {
      value: "results",
      children: /*#__PURE__*/jsxs("section", {
        ref: ref,
        className: container,
        children: [/*#__PURE__*/jsx(TaskHeader, {
          ...props,
          rootRef: ref,
          type: "results"
        }), /*#__PURE__*/jsxs("div", {
          className: content,
          children: [/*#__PURE__*/jsxs("div", {
            className: headerAndPie,
            children: [/*#__PURE__*/jsx(HideFor, {
              breakpoint: breakpoints.desktop,
              children: /*#__PURE__*/jsx(ResultsHeader, {})
            }), /*#__PURE__*/jsx("aside", {
              className: pieChart,
              children: /*#__PURE__*/jsx(ResultsPieChart, {
                context: "results"
              })
            })]
          }), /*#__PURE__*/jsxs("div", {
            className: tasksWrapper,
            children: [/*#__PURE__*/jsx(ShowFor, {
              breakpoint: breakpoints.desktop,
              children: /*#__PURE__*/jsx(ResultsHeader, {})
            }), /*#__PURE__*/jsx("div", {
              className: tasksContainer,
              children: !!tasksWithEntries?.length && /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx(HideFor, {
                  breakpoint: breakpoints.mobile,
                  children: /*#__PURE__*/jsxs("div", {
                    className: taskAccordionsHeader,
                    "aria-hidden": true,
                    children: [/*#__PURE__*/jsx("div", {
                      children: "Opgaver"
                    }), shouldShowReport(component.data.settings.flowType) && /*#__PURE__*/jsx("div", {
                      children: "Svar i opgaven"
                    })]
                  })
                }), /*#__PURE__*/jsx("div", {
                  ref: tasksRef,
                  className: taskAccordions,
                  children: tasksWithEntries?.map((task, index) => /*#__PURE__*/jsx(TaskAccordion, {
                    task: task,
                    index: index
                  }, task.id))
                })]
              })
            })]
          })]
        }), /*#__PURE__*/jsx(ResultsFooter, {
          rootRef: ref,
          component: props.component,
          onShareWithTeacher: props.onShareWithTeacher,
          onResetEntry: props.onResetEntry
        })]
      })
    })
  });
}

export { ResultsPage };
//# sourceMappingURL=_page.results.js.map
